<template>
    <div class="sa-free-page">
        <div class="sa-free-page-header">
            <b-card class="sa-card sa-card-border" header="Dettagli Laboratorio" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice</label>
                        <span class="sa-data">{{ jsonData.codice }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Denominazione</label>
                        <span class="sa-data">{{ jsonData.descrizione }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div class="sa-free-page-body">
            <b-card class="sa-card sa-card-border" header="Lista Reparti" header-tag="header" footer-tag="footer" title="">
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovoReparto" class="mb-2"> <font-awesome-icon icon="plus"> </font-awesome-icon> Aggiungi</b-button>
                <b-table sticky-header ref="table" stacked="lg" :key="listKey" striped hover :items="jsonData.listaReparti" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <!--  <template #cell(actions)="{ item }">
                        <b-container class="bv-example-row">
                            <b-button size="sm" variant="btn btn-outline-info waves-effect waves-light width-sm no-text" title="Associa Utenti" @click="onClickAssociaUtenti(item)">
                                <b-icon icon="people-fill"></b-icon>
                            </b-button>
                        </b-container>
                    </template> -->
                </b-table>
            </b-card>
        </div>
        <rsa-configurazione-struttura-provenienza-reparti-edit-modal-component ref="mdlRsaConfigurazioneStrutturaProvenienzaRepartiEdit" @onSave="onSave" />
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneStrutturaProvenienzaRepartiEditModalComponent from "./RsaConfigurazioneStrutturaProvenienzaRepartiEditModalComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { RsaConfigurazioneStrutturaProvenienzaRepartiEditModalComponent },
    data() {
        return {
            id: null,
            strutturaOptions: [],
            pathResource: "/rsastruttureprovenienza",
            jsonData: {},
            showModalLoading: false,
            idRsaStrutturaProvenienza: null,
            perPage: 10000,
            listKey: 100,
            currentPage: 1,
            fields: [
                {
                    label: "",
                    key: "index",
                },
                {
                    label: "Codice",
                    key: "codiceReparto",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Descrizione",
                    key: "descrizioneReparto",
                    sortable: true,
                    // thStyle: "width: 18rem",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    methods: {
        init() {
            let me = this;
            // me.idRsaStrutturaProvenienza = id;
            me.idRsaStrutturaProvenienza = this.$route.params.id;
            me.loadData();
        },
        loadData() {
            let me = this;
            let path = me.pathResource + "/" + me.idRsaStrutturaProvenienza;
            me.loadDataResources(path, null, me.loadDataSuccess, null);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        onClickAssociaUtenti(item) {
            let me = this;
            me.$refs.mdlAssociaUtenteLaboratorio.init(item);
        },
        onClickNuovoReparto() {
            let me = this;
            me.$refs.mdlRsaConfigurazioneStrutturaProvenienzaRepartiEdit.init(me.idRsaStrutturaProvenienza);
        },
        onSave(data) {
            console.log(data);
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style></style>
